var _g, _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnansweredEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18037_15113)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18037_15113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.75C10.0716 21.75 8.18657 21.1782 6.58319 20.1068C4.97982 19.0355 3.73013 17.5127 2.99218 15.7312C2.25422 13.9496 2.06114 11.9892 2.43735 10.0979C2.81355 8.20656 3.74215 6.46928 5.10571 5.10571C6.46928 3.74215 8.20656 2.81355 10.0979 2.43735C11.9892 2.06114 13.9496 2.25422 15.7312 2.99218C17.5127 3.73013 19.0355 4.97982 20.1068 6.58319C21.1782 8.18657 21.75 10.0716 21.75 12C21.745 14.5843 20.7162 17.0614 18.8888 18.8888C17.0614 20.7162 14.5843 21.745 12 21.75ZM12 3.75C10.3683 3.75 8.77326 4.23386 7.41655 5.14038C6.05984 6.0469 5.00242 7.33538 4.378 8.84287C3.75358 10.3504 3.5902 12.0092 3.90853 13.6095C4.22685 15.2098 5.01259 16.6799 6.16637 17.8336C7.32016 18.9874 8.79017 19.7732 10.3905 20.0915C11.9909 20.4098 13.6497 20.2464 15.1571 19.622C16.6646 18.9976 17.9531 17.9402 18.8596 16.5835C19.7661 15.2268 20.25 13.6317 20.25 12C20.2475 9.81273 19.3775 7.71575 17.8309 6.16911C16.2843 4.62248 14.1873 3.75249 12 3.75Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11.75C17 11.9489 16.9506 12.1397 16.8627 12.2803C16.7748 12.421 16.6556 12.5 16.5312 12.5H7.46875C7.34443 12.5 7.2252 12.421 7.13729 12.2803C7.04939 12.1397 7 11.9489 7 11.75C7 11.5511 7.04939 11.3603 7.13729 11.2197C7.2252 11.079 7.34443 11 7.46875 11H16.5312C16.6556 11 16.7748 11.079 16.8627 11.2197C16.9506 11.3603 17 11.5511 17 11.75Z",
    fill: "#C4C4C4"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 6C13.125 3.30852 15.3085 1.125 18 1.125C20.6915 1.125 22.875 3.30852 22.875 6C22.875 8.69148 20.6915 10.875 18 10.875C15.3085 10.875 13.125 8.69148 13.125 6ZM18 1.875C15.7227 1.875 13.875 3.72273 13.875 6C13.875 8.27727 15.7227 10.125 18 10.125C20.2773 10.125 22.125 8.27727 22.125 6C22.125 3.72273 20.2773 1.875 18 1.875Z",
    fill: "#EB793F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2.625C18.2071 2.625 18.375 2.79289 18.375 3V6H20.25C20.4571 6 20.625 6.16789 20.625 6.375C20.625 6.58211 20.4571 6.75 20.25 6.75H18C17.7929 6.75 17.625 6.58211 17.625 6.375V3C17.625 2.79289 17.7929 2.625 18 2.625Z",
    fill: "#EB793F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18037_15113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18037_15113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnansweredEmpty);
export default __webpack_public_path__ + "static/media/icon-unanswered-empty.05743004dc8ffa0778c3a5b79780402d.svg";
export { ForwardRef as ReactComponent };